import { EntityStatusTypes } from "@enums/entity-status-types";
import { ApAssertionStatusMap } from "@idw-types/data/ap-assertion-status-map/ap-assertion-status-map";
import { AxnAssertionStatusMap } from "@idw-types/data/reference-data/axn";
import { ApAssertion } from "@idw-types/data/reference-data/generic";
import { CommonReferenceData } from "@idw-types/state/common-reference-data-state";

export const getActiveElements = <T extends { status: EntityStatusTypes }>(array: Array<T>) => {
    return (array || []).filter(item => item.status === EntityStatusTypes.ACTIVE);
}

export const getActiveReferenceData = (referenceData: Partial<CommonReferenceData>): Partial<CommonReferenceData> => {
    return Object.keys(referenceData).reduce((activeReferenceData, referenceDataName: keyof Omit<CommonReferenceData, "serviceOfferingRefreshRateDefault">) => {
        activeReferenceData[referenceDataName] = getActiveElements<any>(referenceData[referenceDataName]);
        return activeReferenceData;
    }, {} as Partial<CommonReferenceData>);
}

export const isAllowedToRestore = (canRestore: boolean, relyingPartyStatus: EntityStatusTypes, companyStatus: EntityStatusTypes) => {
    return canRestore && relyingPartyStatus === EntityStatusTypes.ACTIVE && companyStatus === EntityStatusTypes.ACTIVE;
}

export const getApAssertionStatusMaps = (
    apAssertions: Array<ApAssertion>,
    axnAssertionStatusMaps: Array<AxnAssertionStatusMap>,
    assertionStatusDefaults: Array<string>
) => {
    const combinedData: Array<ApAssertionStatusMap> = [];

    apAssertions.forEach(apAssertion => {
        let apAssertionStatusIDs = axnAssertionStatusMaps
            .filter(statusMap => statusMap.apAssertionID === apAssertion.id)
            .map(statusMap => statusMap.availableAssertionStatusID);

        if (apAssertionStatusIDs.length === 0) {
            apAssertionStatusIDs = assertionStatusDefaults;
        }

        combinedData.push({
            apAssertionID: apAssertion.id,
            assertionID: apAssertion.assertionID,
            serviceOfferingID: apAssertion.serviceOfferingID,
            assertionStatusIDs: apAssertionStatusIDs
        })
    });

    return combinedData;
};